<template>
  <b-modal
      ref="modal"
      size="lg"
      centered
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      id="edit-tutor-task"
      title="Sửa tác vụ Gia sư"
      hide-footer
      @show="getData()"
  >
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height:200px;">
      <b-spinner label="Loading..."></b-spinner>
    </div>

    <ValidationObserver v-else v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="off" class="container px-0">
        <div class="row">
          <!-- Loại tác vụ (Disabled, fixed 'Gia sư') -->
          <div class="col-md-6 mb-3">
            <label>Loại tác vụ</label>
            <el-input v-model="form.typeLabel" :disabled="true" />
          </div>

          <!-- Phân loại (Disabled) -->
          <div class="col-md-6 mb-3">
            <label>Phân loại</label>
            <el-input v-model="form.categoryLabel" :disabled="true" />
          </div>

          <!-- Thời gian bắt đầu (Disabled) -->
          <div class="col-md-6 mb-3">
            <label>Thời gian bắt đầu làm việc</label>
            <date-picker
                v-model="form.startAt"
                type="datetime"
                format="DD-MM-YYYY HH:mm"
                value-type="YYYY-MM-DD HH:mm:ss"
                :time-picker-options="timePickerOptions"
                :disabled="true"
            />
          </div>

          <!-- Thời gian kết thúc (Disabled) -->
          <div class="col-md-6 mb-3">
            <label>Thời gian kết thúc làm việc</label>
            <date-picker
                v-model="form.endAt"
                type="datetime"
                format="DD-MM-YYYY HH:mm"
                value-type="YYYY-MM-DD HH:mm:ss"
                :time-picker-options="timePickerOptions"
                :disabled="true"
            />
          </div>

          <!-- Học viên cần gia sư (Disabled) -->
          <div class="col-md-6 mb-3">
            <label>Học viên cần gia sư</label>
            <el-input v-model="form.studentLabel" :disabled="true" placeholder="Học viên" />
          </div>

          <div v-if="isSupplementTutor" class="col-md-6 mb-3">
            <label>Sĩ số <span class="text-danger">*</span></label>
            <ValidationProvider name="Sĩ số" rules="required|integer|min_value:1" v-slot="{ errors }">
              <el-input
                  v-model.number="form.capacity"
                  type="number"
                  :min="1"
                  placeholder="Nhập sĩ số"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>

          <!-- Người phụ trách (Droplist) -->
          <div class="col-md-6 mb-3">
            <label>Người phụ trách <span class="text-danger">*</span></label>
            <ValidationProvider name="Người phụ trách" rules="required" v-slot="{ errors }">
              <el-select
                  v-model="form.assigneeId"
                  placeholder="Chọn người phụ trách"
                  class="w-100"
                  filterable
                  clearable
                  :append-to-body="true"
                  :disabled="!form.startAt || !form.endAt"
                  @focus="fetchFreeTutors"
                  :loading="searchLoading"
              >
                <el-option
                    v-for="u in freeTutors"
                    :key="u.id"
                    :label="`${u.name} - ${u.phone}`"
                    :value="u.id"
                />
              </el-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
            <small class="text-muted d-block mt-1">Danh sách hiển thị: Nhân sự trống tác vụ trong lịch làm việc và trong khung giờ đã chọn.</small>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-2">
          <el-button @click="hide()">Hủy</el-button>
          <el-button type="primary" class="ml-2" native-type="submit" :loading="submitting" :disabled="submitting">Cập nhật</el-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import moment from 'moment-timezone'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

// Đổi các action dưới đây theo store của bạn (ví dụ GET_FREE_TUTOR thay cho GET_FREE_ADMIN nếu cần)
import {
  GET_DETAIL_TASK,
  GET_FREE_ADMIN, GET_TUTOR_DETAIL_TASK, // <-- nếu có action riêng cho tutor, đổi tên import & nơi dispatch tương ứng
  UPDATE_OTHER_TASK, UPDATE_TUTOR_TASK
} from "@/core/services/store/tutor/tutor.module";

export default {
  name: 'EditTutorTask',
  components: { DatePicker },
  props: {
    task: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      submitting: false,
      loading: false,
      searchLoading: false,
      freeTutors: [],
      timePickerOptions: {
        start: '08:00',
        step: '00:15',
        end: '22:00',
        format: 'HH:mm'
      },
      form: {
        id: null,
        // các field hiển thị
        typeLabel: 'Gia sư',       // cố định: “Gia sư”
        categoryLabel: '',         // phân loại tác vụ gia sư (từ API)
        startAt: '',               // YYYY-MM-DD HH:mm:ss (disabled)
        endAt: '',                 // YYYY-MM-DD HH:mm:ss (disabled)
        studentLabel: '',          // thông tin học viên (disabled)
        capacity: null,
        // field thực sự cần submit
        assigneeId: null,
        userId: null
      },
      currentAssignee: null,
    }
  },
  computed: {
    isSupplementTutor () {
      return Number(this.task?.subtype) === 8
    }
  },
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },

    async getData () {
      try {
        this.loading = true
        const res = await this.$store.dispatch(GET_TUTOR_DETAIL_TASK, this.task?.code)
        const d = res?.data || {}

        // Map dữ liệu về form (giữ đúng yêu cầu hiển thị/disable)
        this.form.id            = d.id ?? null
        this.form.typeLabel     = 'Gia sư' // cố định theo yêu cầu
        this.form.categoryLabel = d.subtype_label || d.category || '' // tuỳ API
        this.form.startAt       = d.start_date || ''
        this.form.endAt         = d.end_date || ''
        // Học viên cần gia sư: tuỳ API - ví dụ: d.student_name + ' - ' + d.student_phone
        this.form.studentLabel  = d.student_label || d.user_name || d.object_handle || ''
        this.form.capacity      = d.student_count?.capacity ?? d.capacity ?? null
        this.form.assigneeId    = d?.admin_profile_id || null
        this.form.userId = d?.user_id || null
        this.currentAssignee = {id:d?.admin_profile_id ,name:d?.admin_profile_name,phone:d?.admin_profile_phone}
        this.freeTutors.push(this.currentAssignee)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async fetchFreeTutors () {
      console.log(this.task,'this.task')
      if (!this.form.startAt || !this.form.endAt) return
      const payload = {
        start_date: moment(this.form.startAt).format('YYYY-MM-DD HH:mm:ss'),
        end_date  : moment(this.form.endAt).format('YYYY-MM-DD HH:mm:ss'),
        user_id : this.form.userId
      }
      try {
        this.searchLoading = true
        // Nếu bạn có action riêng cho gia sư (ví dụ GET_FREE_TUTOR) hãy thay ở đây
        const res = await this.$store.dispatch(GET_FREE_ADMIN, payload)
        this.freeTutors = Array.isArray(res?.data) ? res.data : []
      } catch (e) {
        console.error(e)
      } finally {
        this.searchLoading = false
      }
    },

    async onSubmit () {
      try {
        this.submitting = true
        const payload = {
          admin_profile_id: this.form.assigneeId,
          id: this.form.id
        }
        if (this.isSupplementTutor) {
          payload.capacity = this.form.capacity
        }
        await this.$store.dispatch(UPDATE_TUTOR_TASK, payload)
        this.$notify({
          title: 'Success',
          message: 'Cập nhật thành công',
          type: 'success'
        })
        this.$emit('loadList')
        this.hide()
      } catch (e) {
        console.error(e)
        this.$notify.error({
          title: 'Error',
          message: `${e?.data?.message ?? 'Đã có lỗi xảy ra'}`
        })
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
:deep(.modal-content){ border-radius: 6px; }
:deep(.modal-body){ padding-top: 16px !important; padding-bottom: 8px !important; }
h5{ font-weight: 600; }
</style>
